// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MediaManager_wrapper__ELGmH","switchWatermarkLabel":"MediaManager_switchWatermarkLabel__3dxmb"};